import distributionApi from 'services/api/distribution';
import { Statistics, StatisticsLoader, StatisticsError } from './components';

const StatisticsInfo = () => {
  const { data, isLoading, isError } =
    distributionApi.useGetReleasesStatisticsQuery();

  if (isLoading || !data) {
    return <StatisticsLoader />;
  }

  if (isError) {
    return <StatisticsError />;
  }

  return <Statistics stats={data} />;
};

export default StatisticsInfo;
